import React from 'react';
import { ReactComponent as CartIcon } from '../../../icons/svg/cart.svg';
import { Badge } from '../../../components/badge';
import { cva } from 'class-variance-authority';
import { VariantProps } from 'class-variance-authority';
import { cn } from '../../../utils/cn';

const _cartIconVariants = cva('size-5', {
    variants: {
        fill: {
            dark: 'fill-gray-900',
            light: 'fill-gray-50',
        },
    },
    defaultVariants: {
        fill: 'dark',
    },
});

interface UserCartProps extends VariantProps<typeof _cartIconVariants> {
    count: number;
    onUserCartClick: () => void;
}

export const UserCart = (props: UserCartProps) => {
    const { count, fill, onUserCartClick } = props;

    return count > 0 ? (
        <button
            className="relative -top-1 md:-top-1.5"
            onClick={onUserCartClick}
        >
            <div className="absolute -right-1 -top-1 flex">
                {count > 0 && (
                    <Badge
                        size="centeredCompact"
                        text={count > 9 ? 'small' : 'default'}
                        color={fill === 'dark' ? 'default' : 'destructive'}
                    >
                        {count > 99 ? '99+' : count}
                    </Badge>
                )}
            </div>
            <div color="transparent" aria-label="Cart">
                <CartIcon
                    className={cn(_cartIconVariants({ fill }), 'size-6')}
                />
            </div>
        </button>
    ) : null;
};
